"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ERC721__factory = exports.ERC20__factory = exports.ERC1155__factory = exports.factories = void 0;
exports.factories = require("./factories");
var ERC1155__factory_1 = require("./factories/ERC1155__factory");
Object.defineProperty(exports, "ERC1155__factory", { enumerable: true, get: function () { return ERC1155__factory_1.ERC1155__factory; } });
var ERC20__factory_1 = require("./factories/ERC20__factory");
Object.defineProperty(exports, "ERC20__factory", { enumerable: true, get: function () { return ERC20__factory_1.ERC20__factory; } });
var ERC721__factory_1 = require("./factories/ERC721__factory");
Object.defineProperty(exports, "ERC721__factory", { enumerable: true, get: function () { return ERC721__factory_1.ERC721__factory; } });
//# sourceMappingURL=index.js.map